import {ref, computed} from 'vue';
import {defineStore} from 'pinia';
import { useCookies } from "vue3-cookies";

declare function gtag(event: string, action: string, params: { [key: string]: any }): void;

export const useDarkModeStore = defineStore('darkMode', () => {
    const darkMode = ref(JSON.parse(localStorage.getItem("darkMode") || "false"));
    const { cookies } = useCookies();

    updateDarkMode(darkMode.value)
    async function updateDarkMode(value: boolean) {
        darkMode.value = value
        localStorage.setItem("darkMode", JSON.stringify(darkMode.value));
        document.documentElement.classList.toggle('bs-dark', value);
        // Storing in a cookie also so that PHP screens can read it.
        if (darkMode.value) {
            cookies.set('darkMode', '1');
        } else {
            cookies.remove('darkMode');
        }

        gtag('event', 'user_setting', {
            theme_mode: darkMode.value ? 'dark' : 'light'
        });
    }
    const isDarkMode = computed<boolean>({
        get: () => darkMode.value,
        set: (v) => updateDarkMode(v)
    });

    window.addEventListener('beforeprint', () => {
        document.documentElement.classList.remove('bs-dark');
      });
      window.addEventListener('afterprint', () => {
        document.documentElement.classList.toggle('bs-dark', darkMode.value);
      });

    return {isDarkMode}
});